import React, { useState, useMemo } from "react";

import { Modal } from "./Modal";
import {
  formatTafToHTML,
  tkofToRwyData,
  getTkofSettingsByIcao,
  getMagneticVariationFromTkofData,
} from "../helpers";
import { getNOTAM } from "../utilities/helperfunctions";
import { RunwayData } from "./RunwayData";
import { Tabs } from "./Tabs";
import "../style/map.scss";

const tabs = ["Weather", "Notam", "RWY/Wind"];

export const AirportMapModal = ({ isOpen, handleClose, data, adList }) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const notam = useMemo(() => {
    if (!data) return "";

    const notamObj = getNOTAM(data.notamList, data.airportICAO);
    if (!notamObj?.sNOTAM) return "";

    return Array.isArray(notamObj.sNOTAM)
      ? notamObj.sNOTAM[0]
      : notamObj.sNOTAM;
  }, [data?.notamList, data?.airportICAO]);

  let selectedIcao = Array.isArray(data?.airportICAO)
    ? data?.airportICAO[0]
    : data?.airportICAO;

  const tkofData = getTkofSettingsByIcao(selectedIcao, adList);
  const rwyDataArray = tkofData ? tkofToRwyData(tkofData) : [];
  const magneticVariation = getMagneticVariationFromTkofData(tkofData);
  const rawTafData = data?.airportTAF;

  const renderModalContent = (tab) => {
    switch (tab) {
      case tabs[0]: {
        return (
          <>
            <div className="map-modal-paragraph">
              <p>METAR {data?.airportIATA}</p>
              <span>{data?.airportMETAR?.raw_text}</span>
            </div>
            <div className="map-modal-paragraph">
              <p>TAF {data?.airportIATA}</p>
              <span>{formatTafToHTML(rawTafData || "")}</span>
            </div>
          </>
        );
      }
      case tabs[1]: {
        return (
          <div className="map-modal-paragraph">
            <p>NOTAM {data?.airportIATA}</p>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <pre style={{ width: "fit-content" }}>{notam}</pre>
            </div>
          </div>
        );
      }
      default: {
        return (
          <RunwayData
            metar={data?.airportMETAR}
            rwyDataArray={rwyDataArray}
            magneticVariation={magneticVariation}
            tafData={rawTafData}
          />
        );
      }
    }
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="map-modal-container">
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          {data?.airportName}
        </p>
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          handleChangeTab={(tab) => setSelectedTab(tab)}
        />
        {renderModalContent(selectedTab)}
      </div>
    </Modal>
  );
};
